import { createContext } from "react";

import { TerraformWorkflowTool, VcsProvider, Version } from "types/generated";
import { AccessResult } from "utils/access";

export type VersionContextType = {
  version: Version;
  module: {
    id: string;
    moduleSource: string;
    name: string;
    provider: VcsProvider;
    workflowTool: TerraformWorkflowTool;
    current: {
      number: string;
    } | null;
    vcsIntegration: {
      id: string;
    } | null;
  };
  canManageModule: AccessResult;
  canMarkModuleAsBad: AccessResult;
  canDeleteModuleVersion: AccessResult;
};

export const VersionContext = createContext<VersionContextType | undefined>(undefined);
VersionContext.displayName = "VersionContext";
